import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5apqh2a958: FaireBrandEntity = {
  token: "b_5apqh2a958",
  type: "brand",
  name: "Haptics",
  avatarUrl:
    "https://cdn.faire.com/fastly/7412d9dbe862154c50ec585d184e6793c9cbb4d11530a0f33ffb662cdcb14602.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/64cd6e5530e64e84cabbeb04d51b3fe31f0552c1f6724c187dd3b9681c46a7f7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7412d9dbe862154c50ec585d184e6793c9cbb4d11530a0f33ffb662cdcb14602.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/64cd6e5530e64e84cabbeb04d51b3fe31f0552c1f6724c187dd3b9681c46a7f7.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.6,
  reviewCount: 101,
  isInsider: true,
  description:
    "Located in Los Angeles, CA, we specialize in designing and manufacturing trendy, feminine and comfortable Young Contemporary clothing. We present a wide selection of high quality, unique styles for every fashion conscious women. Through our innovation and supply of quality products, we are able to establish our own trendy and timeless designs. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:54.383Z",
    importedBy: "entity-db-cli",
  },
};
